// extracted by mini-css-extract-plugin
export default {"title":"XXaKKpK2","text":"aRVCLybe"};